module.exports = __webpack_public_path__ + "img/active_icon.44bb225a.png";